import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import TarotReadingTeeup from './tarot-reading/teeup';
import TarotReadingSampleInterp from './tarot-reading/sample-interp';
import _ from 'underscore';

class Component extends BaseComponent {
    componentDidMount() {
        const bgImg = 'background-image: url(https://gfx.tarot.com/images/site/tarot/' + this.props.upc;
        const styleSheet = document.createElement('style');
        const styleRules = [
            'tarot-reading .icon-teeup { ' + bgImg + '/icon.svg); }',
            'tarot-reading-deck-card { ' + bgImg + '/card-back.svg); }',
            'tarot-reading-deck-card:hover { ' + bgImg + '/card-back-highlight.svg); }',
            'tarot-reading-deck-card.shuffle { ' + bgImg + '/card-back-highlight.svg); }',
            'tarot-spread .outline { ' + bgImg + '/question-grey.svg); }',
            'tarot-spread spread-card.next .outline { ' + bgImg + '/question-highlight.svg); }',
        ];

        styleRules.forEach((rule) => {
            styleSheet.appendChild(document.createTextNode(rule));
        });

        document.head.appendChild(styleSheet);

        this.props.init(this.props.upc, this.props.type);

        if (this.props.deck) {
            if (!this.props.upc.match(/two-hearts-.*/)) {
                const spread = _.shuffle(this.props.deck.cards).map(card => card.index);
                this.props.updateSpread(spread);
            }
        } else {
            this.props.requireDeck();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.spread != this.props.spread) {
            return true;
        }

        if (nextProps.deck != this.props.deck) {
            return true;
        }

        if (nextProps.sample_interps != this.props.sample_interps) {
            return true;
        }

        if (nextProps.user != this.props.user) {
            return true;
        }

        return false;
    }

    render({ type, upc, spread }) {
        let view = null;

        if (upc == 'yes-or-no-tarot-redux') {
            view = spread && spread.length == 8 ? 'view-2' : 'view-1';
        }

        return (
            <tarot-reading className={type} upc={upc} type={type} view={view}>
                {this.renderReadingOrInterp(view)}
            </tarot-reading>
        );
    }

    renderReadingOrInterp(view) {
        if (this.props.sample_interps) {
            return (
                <TarotReadingSampleInterp type={this.props.type} />
            );
        }

        return (
            <TarotReadingTeeup upc={this.props.upc} type={this.props.type} view={view} />
        );
    }
}

const mapStateToProps = (state) => ({
    deck: state.deck,
    spread: state.spread,
    sample_interps: state['tarot-reading'].interps,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    init: (upc, type) => dispatch({
        type: 'tarot-reading:init',
        payload: {
            upc: upc,
            type: type,
        },
    }),
    requireDeck: () => dispatch({ type: 'deck:required', payload: 'universal_waite' }),
    updateSpread: (payload) => dispatch ({
        type: 'spread:update',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
